import { render } from "./OcMoveShared.vue?vue&type=template&id=00d7df19&scoped=true"
import script from "./OcMoveShared.vue?vue&type=script&lang=js"
export * from "./OcMoveShared.vue?vue&type=script&lang=js"

import "./OcMoveShared.vue?vue&type=style&index=0&id=00d7df19&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d7df19"]])

export default __exports__